import { ApiService } from "qccat-ui";
import { WebServiceUrl, LoginUrl, NotifyRequestRejectedUrl } from "../config/appUrlConfig";

export const dashboardApiService = new ApiService( { apiUrl: WebServiceUrl, loginUrl: LoginUrl, notifyRequestRejectedUrl: NotifyRequestRejectedUrl });